/**
 * Domain error with a stable code (see `docs/error-codes.md`).
 */
export interface DomainError {
  /** Stable error code, for example `TT-1001`. */
  readonly code: string;
  /** English description for logs and developers. */
  readonly message: string;
}

/** Result of an operation that can fail in an expected way (spec 5.3). */
export type Result<T> =
  { readonly ok: true; readonly value: T } | { readonly ok: false; readonly error: DomainError };

/**
 * Creates a successful result.
 *
 * @param value - The value.
 * @returns The result.
 */
export function success<T>(value: T): Result<T> {
  const result: Result<T> = { ok: true, value };

  return result;
}

/**
 * Creates a failed result.
 *
 * @param code - Error code.
 * @param message - Error description.
 * @returns The result.
 */
export function failure<T>(code: string, message: string): Result<T> {
  const result: Result<T> = { ok: false, error: { code, message } };

  return result;
}
